import { useQuery } from "@tanstack/react-query";

import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";
import type { ContractRequestDetailResponse } from "~/types/common";

/**
 * 신규 e-sign 계약(HIST_CONTRACT_REQUEST) 상세 조회 훅.
 *
 * 사장님/보호자 두 컨트롤러 모두 동일한 응답 DTO 를 사용하지만 권한 체크가 달라
 *  화면 측에서 적절한 훅을 선택해 호출한다.
 */

const QUERY_KEYS = {
  businessDetail: ["business", "contract-request", "detail"] as const,
  userDetail: ["user", "contract-request", "detail"] as const,
};

const getBusinessContractRequestDetail = async (
  requestSeq: number,
): Promise<ContractRequestDetailResponse> => {
  const { data } = await privateHttp.get<ContractRequestDetailResponse>(
    `${API_ENDPOINTS.CONTRACT_REQUEST.BUSINESS_DETAIL}/${requestSeq}`,
  );
  return data;
};

const getUserContractRequestDetail = async (
  requestSeq: number,
): Promise<ContractRequestDetailResponse> => {
  const { data } = await privateHttp.get<ContractRequestDetailResponse>(
    `${API_ENDPOINTS.CONTRACT_REQUEST.USER_DETAIL}/${requestSeq}`,
  );
  return data;
};

export const useBusinessContractRequestDetail = (requestSeq: number) =>
  useQuery({
    queryKey: [...QUERY_KEYS.businessDetail, requestSeq],
    queryFn: () => getBusinessContractRequestDetail(requestSeq),
    enabled: !!requestSeq && requestSeq > 0,
    staleTime: 60 * 1000,
  });

export const useUserContractRequestDetail = (requestSeq: number) =>
  useQuery({
    queryKey: [...QUERY_KEYS.userDetail, requestSeq],
    queryFn: () => getUserContractRequestDetail(requestSeq),
    enabled: !!requestSeq && requestSeq > 0,
    staleTime: 60 * 1000,
  });
